import { render, staticRenderFns } from "./IGChannelStatusWidget.vue?vue&type=template&id=62e7940b&scoped=true"
import script from "./IGChannelStatusWidget.vue?vue&type=script&lang=js"
export * from "./IGChannelStatusWidget.vue?vue&type=script&lang=js"
import style0 from "./IGChannelStatusWidget.vue?vue&type=style&index=0&id=62e7940b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e7940b",
  null
  
)

export default component.exports